import React from 'react';
import { TrendingUp, AlertCircle, Package, Container } from 'lucide-react';
import Icon from '../../../components/AppIcon';


const KPICard = ({ title, value, icon, color }) => {
  const colorClasses = {
    green: 'bg-green-50 text-green-600 border-green-200',
    orange: 'bg-orange-50 text-orange-600 border-orange-200',
    blue: 'bg-blue-50 text-blue-600 border-blue-200',
    purple: 'bg-purple-50 text-purple-600 border-purple-200'
  };

  const icons = {
    euro: TrendingUp,
    alert: AlertCircle,
    package: Package,
    container: Container
  };

  const Icon = icons?.[icon] || Package;

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow">
      <div className="flex items-center justify-between mb-4">
        <div className={`p-3 rounded-lg border ${colorClasses?.[color]}`}>
          <Icon size={24} />
        </div>
      </div>
      <h3 className="text-gray-600 text-sm font-medium mb-2">{title}</h3>
      <p className="text-3xl font-bold text-gray-900">{value}</p>
    </div>
  );
};

export default KPICard;